import Loadable from 'react-loadable';

import { LoadingPage } from 'components/LoadingPage';

export const PaymentsLoadable = Loadable({
  loader: () => import('./index'),
  loading: LoadingPage,
});
